export const PROSE_INLINE_CODE_CLASSES = [
  '[&_code]:rounded-sm',
  '[&_code]:bg-slate-100',
  '[&_code]:px-1',
  '[&_code]:py-px',
  '[&_code]:font-medium',
  '[&_code]:text-slate-700',
  '[&_code]:before:content-none',
  '[&_code]:after:content-none',
  '[&_pre_code]:rounded-none',
  '[&_pre_code]:bg-transparent',
  '[&_pre_code]:p-0',
  '[&_pre_code]:font-normal',
  '[&_pre_code]:text-inherit',
].join(' ');

export const MESSAGE_TABLE_PROSE_CLASSES = [
  'prose-table:block',
  'prose-table:max-w-full',
  'prose-table:overflow-x-auto',
  'prose-table:my-2',
  'prose-table:w-full',
  'prose-table:table-auto',
  'prose-table:text-xs',
  'prose-th:min-w-40',
  'prose-td:min-w-40',
  'prose-th:text-xs',
  'prose-td:text-xs',
  'prose-th:whitespace-normal',
  'prose-td:whitespace-normal',
  'prose-th:break-words',
  'prose-td:break-words',
  'prose-th:align-top',
  'prose-td:align-top',
  'prose-th:px-2',
  'prose-td:px-2',
  'prose-th:py-1',
  'prose-td:py-1',
].join(' ');

export const MESSAGE_PROSE_CLASSES = [
  'prose',
  'prose-sm',
  'prose-slate',
  'max-w-full',
  'break-words',
  'wrap-break-word',
  'prose-p:my-2',
  'prose-pre:my-2',
  'prose-ul:my-2',
  'prose-ol:my-2',
  'prose-li:my-1',
  'prose-li:break-words',
  'prose-headings:mt-4',
  'prose-headings:mb-2',
  'prose-hr:my-10',
  'prose-hr:border-slate-200',
  '[&_hr]:my-10',
  '[&_hr]:border-slate-200',
  'prose-a:break-words',
  PROSE_INLINE_CODE_CLASSES,
  MESSAGE_TABLE_PROSE_CLASSES,
].join(' ');
